import React from "react";
import { useTranslation } from "react-i18next";
import ListingCard from "./ListingCard";
import { BookOpen } from "lucide-react";

const EMPTY_TITLE = { nl: "Geen bedrijven gevonden", de: "Keine Unternehmen gefunden", en: "No businesses found" };
const EMPTY_BODY = { nl: "Probeer een andere zoekterm of pas je filters aan. Weet je zeker dat we iets missen? Laat het ons weten.", de: "Versuchen Sie einen anderen Suchbegriff oder passen Sie die Filter an. Fehlt etwas? Sagen Sie es uns.", en: "Try a different search term or adjust the filters. Think we're missing something? Let us know." };

export const ListingGrid = ({ items = [], total = 0, loading = false }) => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language || "nl";
  return (
    <div data-testid="listing-grid-wrapper">
      <p
        data-testid="results-count"
        className="text-sm font-[Inter] text-[#5A7594] mb-6"
      >
        {loading ? (
          <span className="inline-block w-40 h-4 bg-[#E4EEF5] rounded animate-pulse" />
        ) : (
          <span className="text-[#173A5E] font-semibold">
            {t("common.resultaten_gevonden", { count: total })}
          </span>
        )}
      </p>

      {loading ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {Array.from({ length: 8 }).map((_, i) => (
            <div
              key={i}
              className="rounded-2xl overflow-hidden bg-white border border-[#E4EEF5]"
            >
              <div className="aspect-[4/3] bg-[#F4F8FB] animate-pulse" />
              <div className="p-5 space-y-2">
                <div className="h-4 bg-[#F4F8FB] rounded animate-pulse w-3/4" />
                <div className="h-3 bg-[#F4F8FB] rounded animate-pulse w-1/2" />
              </div>
            </div>
          ))}
        </div>
      ) : items.length === 0 ? (
        <div
          data-testid="empty-state"
          className="text-center py-16 bg-white rounded-2xl border border-[#E4EEF5]"
        >
          <div className="w-14 h-14 rounded-full bg-[#F4F8FB] flex items-center justify-center mx-auto mb-4">
            <BookOpen className="w-6 h-6 text-[#2E9CD6]" />
          </div>
          <h3 className="text-xl font-[Poppins] font-bold text-[#173A5E] mb-2">
            {EMPTY_TITLE[lang] || EMPTY_TITLE.nl}
          </h3>
          <p className="text-[#5A7594] font-[Inter] max-w-sm mx-auto">
            {EMPTY_BODY[lang] || EMPTY_BODY.nl}
          </p>
        </div>
      ) : (
        <div
          data-testid="listing-grid"
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5"
        >
          {items.map((it) => (
            <ListingCard key={it.slug} listing={it} />
          ))}
        </div>
      )}
    </div>
  );
};

export default ListingGrid;
